var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionSplit',{staticClass:"reverse our-portfolio",attrs:{"id":"SectionOurApproach","formats":[],"headline":_vm.$t('headline'),"src":"../../assets/our-approach.jpg"}},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('content'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }